
export const customDataTableStyles = {
	cells: {
		style: {
            padding: '15px'
		},
	},
    responsiveWrapper: {
        style: {
            maxHeight: 'none'
        }
    }
};

export const constrainedCustomDataTableStyles = {
	cells: {
		style: {
            padding: '15px'
		},
	},
    responsiveWrapper: {
        style: {
            maxHeight: 'none',
            height: '60%'
        }
    }
};